
import React from "react";
import { useAddAssignment } from "@/hooks/useAddAssignment";
import { AssignmentHeader } from "./assignments/AssignmentHeader";
import { AssignmentLoading } from "./assignments/AssignmentLoading";
import { WorkerSelector } from "./assignments/WorkerSelector";
import { WorksiteSelector } from "./assignments/WorksiteSelector";
import { DateSelector } from "./assignments/DateSelector";
import { AssignmentActions } from "./assignments/AssignmentActions";

export const AddAssignment: React.FC = () => {
  const {
    workers,
    worksites,
    selectedWorker,
    setSelectedWorker,
    selectedWorksite,
    setSelectedWorksite,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    loading,
    handleSubmit,
    handleCancel
  } = useAddAssignment();

  if (loading) {
    return <AssignmentLoading />;
  }

  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <div className="min-h-screen bg-[#F8F8F8] flex flex-col">
      <AssignmentHeader onCancel={handleCancel} />

      {/* Main Content */}
      <main className="flex-1 p-4">
        <form onSubmit={handleFormSubmit} className="space-y-6">
          <WorkerSelector
            workers={workers}
            selectedWorker={selectedWorker}
            onWorkerChange={setSelectedWorker}
          />

          <WorksiteSelector
            worksites={worksites}
            selectedWorksite={selectedWorksite}
            onWorksiteChange={setSelectedWorksite}
          />

          <DateSelector
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
          />
        
          <AssignmentActions
            onCancel={handleCancel}
            onSubmit={handleSubmit}
          />
        </form>
      </main>
    </div>
  );
};
